import styled from '@emotion/styled'

/**
 * DongAccordion — 펼치면 동 chips가 나오는 카드.
 *
 * 적용 케이스:
 *  - 일반구 보유 시군구의 일반구별 카드 (예: "덕양구" + 11개 동)
 *  - 일반구 없는 partial 시군구의 단일 카드 ("전체" + N개 동)
 *
 * 시각 상태:
 *  - chevron `data-open` attribute로 회전 토글
 *  - 본문은 isOpen일 때만 mount (펼치지 않은 카드는 DOM에 없음)
 */

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #f5f5f6;
  border-radius: 16px;
  overflow: hidden;
`

export const Header = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 17px;
  border: 0;
  background: transparent;
  cursor: pointer;

  &:active {
    background: #fafbfc;
  }
`

export const GroupName = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: #1b1c1d;
`

export const HeaderRight = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`

/**
 * "전 지역 가능" 칩 — 시군구 isFullCoverage=true일 때 헤더 우측 카운트 옆에 노출.
 * 디자인: bg #fff4ed (brand weak), text #ff5626 (brand primary), 작은 라운드.
 */
export const FullCoverageChip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 5px;
  background: #fff4ed;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.06px;
  color: #ff5626;
  white-space: nowrap;
`

export const DongCount = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #85878e;
`

export const ChevronIcon = styled.img`
  width: 24px;
  height: 24px;
  transition: transform 200ms ease-out;

  &[data-open] {
    transform: rotate(180deg);
  }
`

export const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid #f5f5f6;
`

export const DongChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 8px;
  background: #f5f5f6;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #3f4145;
`
